export default __webpack_public_path__ + "static/media/bg-change-device-stub.fb694280.png";